import logo from 'assets/header-prevencor-xx.png';
import AssinaturaEletronica from 'components/core/AssinaturaEletronica';
import LaudoActionButtons from 'components/laudos/LaudoActionButtons';
import { Card, Form, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { selectCarotidaById } from 'services/carotida';
import useSWR from 'swr';
import { generatePDFCarotida } from './generatePDFCarotida';

function SecaoCarotidaReport({ titulo, items, mostraMedida = false }) {
  if (!items?.length) return null;
  return (
    <Form.Group className="mb-3">
      <u className="mr-auto">{titulo}</u>
      {items.map((item) => (
        <div key={item.CODANATOMIA} className="row">
          <div className="col-12">
            {item.ANATOMIA}
            {mostraMedida && item.CODANATOMIA === 44 && item.MEDIDA != null
              ? ` ${item.MEDIDA} mm`
              : ''}
            {item.VELOCIDADE ? ` ${item.VELOCIDADE}` : ''}
            {item.INTENSIDADE ? ` ${item.INTENSIDADE}` : ''}
          </div>
        </div>
      ))}
    </Form.Group>
  );
}

export default function ReportCarotida() {
  const { id } = useParams();
  const {
    data: carotida,
    isLoading,
    error,
  } = useSWR(id ? ['carotida', id] : null, () => selectCarotidaById(id));

  const scan = carotida?.carotida?.[0];

  return (
    <Card className="mb-2 mt-2">
      <Card.Header className="text-center font-weight-bold">
        <img
          src={logo}
          alt="Prevencor"
          style={{ display: 'block', maxWidth: '100%', margin: '0 auto 8px' }}
          className="no-print"
        />
        LAUDO DE SCAN DE CARÓTIDAS
      </Card.Header>
      {isLoading && (
        <Card.Body>
          <div className="d-flex justify-content-center align-items-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Card.Body>
      )}
      {error && !isLoading && (
        <Card.Body className="text-center text-danger py-5">
          {error.message || 'Erro ao carregar o laudo.'}
        </Card.Body>
      )}
      {carotida && scan && !isLoading && !error && (
        <>
          <Card.Body>
            <strong className="mr-auto">Nome do Paciente: </strong>
            {`${scan.CODPAC} - ${scan.NOMEPAC}`}
            <br />
            <strong className="mr-auto">Data de Nasc: </strong>
            {scan.dataNascFmt}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Sexo: </strong>
            {scan.SEXOPAC}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {`${scan.idadePAC} anos`}
            <br />
            <strong className="mr-auto">Convênio: </strong>
            {scan.SIGLACONV}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Código: </strong>
            {scan.CODSCAN}
            &nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {scan.dataScanFmt}
            <br />
            <strong className="mr-auto">Médico que Realizou: Dr. </strong>
            {scan.Realizou}
            <br />
            <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
            {scan.Solicitante}
            <hr />
            <Card.Subtitle className="text-center font-weight-bold mt-2">
              SISTEMA CAROTÍDEO DIREITO
            </Card.Subtitle>
            <SecaoCarotidaReport
              titulo="Carótida Comum Direita: "
              items={carotida.ccd}
              mostraMedida
            />
            <SecaoCarotidaReport titulo="Carótida Interna Direita: " items={carotida.cid} />
            <SecaoCarotidaReport titulo="Carótida Externa Direita: " items={carotida.ced} />
            <Card.Subtitle className="text-center font-weight-bold mt-2">
              SISTEMA CAROTÍDEO ESQUERDO
            </Card.Subtitle>
            <SecaoCarotidaReport
              titulo="Carótida Comum Esquerda: "
              items={carotida.cce}
              mostraMedida
            />
            <SecaoCarotidaReport titulo="Carótida Interna Esquerda: " items={carotida.cie} />
            <SecaoCarotidaReport titulo="Carótida Externa Esquerda: " items={carotida.cee} />
            <Card.Subtitle className="text-center font-weight-bold mt-2">
              ARTÉRIAS VERTEBRAIS
            </Card.Subtitle>
            <SecaoCarotidaReport titulo="Artéria Vertebral Direita: " items={carotida.avd} />
            <SecaoCarotidaReport titulo="Artéria Vertebral Esquerda: " items={carotida.ave} />
            {scan.OBSERVACOES && (
              <Form.Group>
                <u className="mr-auto">Observações: </u>
                {(scan.OBSERVACOES || '').split('\n').map((item, idx) => (
                  <div key={idx}>{item}</div>
                ))}
              </Form.Group>
            )}
          </Card.Body>
          <Card.Footer className="text-center no-print">
            <LaudoActionButtons
              actions={[
                {
                  key: 'timbrado',
                  label: 'Timbrado',
                  onClick: () => generatePDFCarotida({ carotida }),
                },
              ]}
            />
          </Card.Footer>
          <Card.Footer className="text-center">
            <AssinaturaEletronica data={scan} nome={scan.Realizou} showPrintButton={false} />
          </Card.Footer>
        </>
      )}
    </Card>
  );
}
